// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3f1fb51b","770":"8833205b"}[chunkId] + ".chunk.js";
};